import cx from 'classnames';
import React, { useMemo } from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../../../Components/UI/Box';

interface LogoProps extends BoxProps {
  name?: string;
  logoUrl?: string | null;
}

const Logo: React.FC<LogoProps> = ({ name = '', logoUrl, ...rest }) => {
  const initials = useMemo(() => {
    return name
      .split(' ')
      .filter((word) => word.length > 0)
      .filter((_, i, all) => i === 0 || i === all.length - 1) // First and last word only
      .map((word) => word[0].toUpperCase())
      .join('');
  }, [name]);

  return (
    <Box
      className={cx(styles['logo'], { [styles['logo-with-initials']]: !logoUrl })}
      display="flex"
      alignItems="center"
      title={name}
      {...rest}
    >
      {!logoUrl && <div className={styles['initials']}>{initials}</div>}
      {logoUrl && <img src={logoUrl} alt={name} />}
    </Box>
  );
};

export default Logo;
